import AddToQueueIcon from '@mui/icons-material/AddToQueue'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import VisibilityRounded from '@mui/icons-material/VisibilityRounded'
import { IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useGetPatientQueueByStaffQuery } from '@/core/services/patient-queue'
import { isPatientInQueue } from '@/features/patient/patient-queue'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { useStartLocalConsultation } from '@/shared/model/useStartLocalConsultation'
import { isPDS } from '@/utils/type-guards'

import { usePatientsTableActions } from '../model/usePatientsTableActions'

type InsPatientActionsProps = {
  patientId: string
  onOpen: (patientId: string) => void
}

export function InsPatientActions({ patientId, onOpen }: InsPatientActionsProps) {
  const { t } = useTranslation()
  const authUser = useAppSelector(selectAuthUser)
  const { data: queueData } = useGetPatientQueueByStaffQuery()
  const { startLocalConsultation } = useStartLocalConsultation()
  const { addToQueue } = usePatientsTableActions()
  const isQueued = Boolean(queueData && isPatientInQueue(patientId, queueData))

  return (
    <Stack direction="row" spacing={0.5} justifyContent="center">
      <Tooltip title={t('page.patients.seeProfileButton.tooltip')}>
        <IconButton aria-label={t('page.patients.seeProfileButton.tooltip')} onClick={() => onOpen(patientId)}>
          <VisibilityRounded htmlColor="#269CA6" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('page.infoPatient.localConsultationButton.label')}>
        <IconButton aria-label={t('page.infoPatient.localConsultationButton.label')} onClick={() => startLocalConsultation(patientId)}>
          <LocalHospitalIcon htmlColor="#269CA6" />
        </IconButton>
      </Tooltip>
      {isPDS(authUser) && (
        <Tooltip title={isQueued ? t('Patient already in queue') : t('page.patients.addToQueueButton.tooltip')}>
          <span>
            <IconButton aria-label={t('page.patients.addToQueueButton.tooltip')} disabled={isQueued} onClick={() => addToQueue(patientId)}>
              <AddToQueueIcon htmlColor={isQueued ? '#ccc' : '#269CA6'} />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Stack>
  )
}
